import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ReportsService } from '../../services/reports/reports.service.abstract';
import { catchError, map, take, takeUntil, tap } from 'rxjs/operators';
import { MessageService } from '../../services/message/message.abstract.service';
import { of, Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IReportTransactionResponse } from '@bciti/types';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { organisationTagSelector } from '../../store/global.selectors';
import { unparse } from 'papaparse';
@Component({
    selector: 'app-exports',
    templateUrl: './exports.component.html',
    styleUrls: ['./exports.component.scss'],
})
export class ExportsComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    org: string = '';

    receiptsDataSource = new MatTableDataSource<IReportTransactionResponse>([]);
    receiptsTableColumns = ['transactionNumber', 'receiptNumber', 'date', 'cardType', 'cardNumber', 'transactionSuccess', 'transactionType', 'total', 'code', 'name', 'phone'];
    receiptsLoading = false;
    receiptsDownloadLoading = false;
    receiptsHasSearchedOnce = false;

    receiptsForm = new FormGroup({
        startDate: new FormControl(undefined),
        endDate: new FormControl(undefined),
    });

    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private reportsService: ReportsService,
        private messageService: MessageService,
        private store: Store<State>,
    ) {}

    ngOnInit(): void {
        this.store
            .select(organisationTagSelector)
            .pipe(
                takeUntil(this.destroy$),
                map((org) => (this.org = org)),
            )
            .subscribe();
    }

    ngAfterViewInit() {
        this.receiptsDataSource.sort = this.sort;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getReceipts(): void {
        this.receiptsLoading = true;

        this.reportsService
            .getReceipts(this.receiptsForm.get('startDate').value, this.receiptsForm.get('endDate').value)
            .pipe(
                take(1),
                map((response) => {
                    this.receiptsDataSource.data = response;
                    this.receiptsLoading = false;
                    this.receiptsHasSearchedOnce = true;
                }),
                catchError((error) => {
                    this.messageService.error(error?.error?.messages[0]);
                    this.receiptsLoading = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    downloadReceiptsAsCSV(): void {
        this.receiptsDownloadLoading = true;

        this.reportsService
            .getReceipts(this.receiptsForm.get('startDate').value, this.receiptsForm.get('endDate').value)
            .pipe(
                take(1),
                map((response) => {
                    const csv = unparse(response, {
                        quotes: true,
                        delimiter: ',',
                        newline: '\r\n',
                    });

                    const startDate = this.receiptsForm.get('startDate').value || new Date();
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const downloadElement = document.createElement('a');
                    downloadElement.href = url;
                    downloadElement.target = '_blank';
                    downloadElement.download = `${this.org}-${startDate.toISOString().split('T')[0]}.csv`;
                    downloadElement.click();
                    this.receiptsDownloadLoading = false;
                }),
                catchError((error) => {
                    console.error(error);
                    this.messageService.error(error?.error?.messages[0]);
                    this.receiptsDownloadLoading = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    // DISPLAY UTIL FUNCTIONS
    getUserName(element: IReportTransactionResponse): string {
        return `${element.firstName} ${element.lastName}`;
    }

    getLastFourCharacters(string: string): string {
        return string.slice(-4);
    }
}
